import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CustomerStudioIcon(props: IconProps) {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <Box as="circle" cx="12" cy="8" r="2.423" stroke="currentColor" />
      <Box as="path" stroke="currentColor" d="M6.607 17.423a5.424 5.424 0 0 1 10.786 0H6.607Z" />
      <rect
        width="3.846"
        height="3.846"
        x="18.577"
        y="1.577"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx=".673"
      />
      <rect
        width="3.846"
        height="3.846"
        x="18.577"
        y="18.577"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx=".673"
      />
      <rect
        width="3.846"
        height="3.846"
        x="1.577"
        y="18.577"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx=".673"
      />
      <rect
        width="3.846"
        height="3.846"
        x="1.577"
        y="1.577"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        rx=".673"
      />
      <Box as="path" stroke="currentColor" d="M3.577 6v12m17-12v12M6 3.423h12m-12 17h12" />
    </Icon>
  );
}
